/* eslint-disable no-console */
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { delay } from 'redux-saga';
import { put, takeLatest, takeEvery, select, call } from 'redux-saga/effects';
import { uniq, flattenDeep, last } from 'lodash';
import { setNotification, getTranslated, locales } from 'utils';
import {
    loadTemplateRes,
    loadTemplateErr,
    addTemplateRes,
    addTemplateErr,
    loadEdiTableTemplateRes,
    editTemplateRes,
    editTemplateErr,
    CheckedTemplatesRes,
    CheckedTemplatesErr,
    toggleTemplateStatusRes,
    toggleTemplateStatusErr,
    loadPackagesForTemplateRes,
    loadPackagesForTemplateErr,
    addBulkPackagesForTemplateRes,
    addBulkPackagesForTemplateErr,
    deleteBulkPackagesForTemplateRes,
    deleteBulkPackagesForTemplateErr,
    clonePackagesToTemplateRes,
    clonePackagesToTemplateErr,
    loadEdiTablePackagesFromTemplateRes,
    loadEdiTablePackagesFromTemplateErr,
    loadDesignTemplateRes,
    loadDesignTemplateErr,
    loadEditableDesignTemplateRes,
    loadEditableDesignTemplateErr,
    loadResellersForDesignTemplateRes,
    loadResellersForDesignTemplateErr,
    loadProductsGroupForDesignTemplateRes,
    loadProductsGroupForDesignTemplateErr,
    editDesignTemplateRes,
    editDesignTemplateErr,
    updateTranslateDesignTemplateRes,
    updateTranslateDesignTemplateErr,
} from '../actions/templateActions';
import {
    getTemplateApi,
    addTemplateApi,
    editTemplateApi,
    toggleTemplateStatusApi,
    attachPackagesToTemplateApi,
    detachPackagesToTemplateApi,
    getPackagesFromTemplateApi,
    getDesignTemplateApi,
    editDesignTemplateApi,
    updateTranslateDesignTemplateApi,
    statusDesignTemplateApi,
} from '../api/templateApi';
import { getPackagesApi } from '../api/packageApi';
import { getUsersApi } from '../api/userApi';
import { getResellersApi } from '../api/resellerApi';
import { getProductGroupsApi } from '../api/productGroupApi';
import {
    LOAD_TEMPLATE,
    ADD_TEMPLATE,
    LOAD_EDITTABLE_TEMPLATE,
    EDIT_TEMPLATE,
    TOGGLE_TEMPLATE_STATUS,
    CHECKED_TEMPLATES,
    LOAD_PACKAGES_FOR_TEMPLATE,
    ADD_BULK_PACKAGES_FOR_TEMPLATE,
    DELETE_BULK_PACKAGES_FOR_TEMPLATE,
    LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE,
    LOAD_DESIGN_TEMPLATES,
    LOAD_EDITABLE_DESIGN_TEMPLATES,
    LOAD_RESELLERS_FOR_DESIGN_TEMPLATES,
    LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES,
    EDIT_DESIGN_TEMPLATE,
} from '../types/templateTypes';

const getTemplate = state => state.template;
const getLayout = state => state.layout;

// L O A D   T E M P L A T E
function* loadTemplateSaga() {
    try {
        const template = yield select(getTemplate);
        const { offset, limit, filters } = template;

        const params = {
            offset,
            limit,
            sort_by: JSON.stringify({ created_at: -1 }),
        };

        const filterParams = {};

        if (filters.name) {
            filterParams.name = {
                operator: 'typing',
                value: filters.name,
            };
        }

        params.filter = JSON.stringify(filterParams);

        const result = yield getTemplateApi(params);
        yield put(loadTemplateRes(result.data));
        // yield put(push('/factory/templates/'));
    } catch (e) {
        console.log(e);
        yield put(loadTemplateErr());
    }
}

export function* loadTemplateWatcher() {
    yield takeLatest(LOAD_TEMPLATE, loadTemplateSaga);
}
// L O A D   T E M P L A T E

// C L O N E   P A C K A G E S   T O   T E M P L A T E
function* clonePackagesToTemplateSaga(data) {
    const { locale } = yield select(getLayout);
    try {
        if (data.packages_id !== undefined) {
            for (let i = 0; i < data.packages_id.length; i += 1) {
                const pack = data.packages_id[i];
                // const params = {
                //     bulk: pack.hits.map(c => ({
                //         package_id: c.id,
                //         template_id: window.location.pathname,
                //     })),
                // };

                const params = {
                    package_id: pack,
                    template_id: data.template_id,
                };
                const result = yield attachPackagesToTemplateApi(params);

                if (result.status === 202) {
                    yield delay(data.packages_id.length * 200);
                    yield put(clonePackagesToTemplateRes());
                }
            }
        }
    } catch (e) {
        console.log(e);
        yield put(clonePackagesToTemplateErr(getTranslated('package.notification.addBulkPackageError', locale)));
        setNotification('error', locale, 'global.error', 'package.notification.addBulkPackageError');
    }
}
// C L O N E   P A C K A G E S   T O   T E M P L A T E

// A D D   N E W   T E M P L A T E
function* addTemplateSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'template.notification.newTemplateAddedSuccess';

    try {
        const formData = new FormData();

        const dataKeys = Object.keys(action.data);
        dataKeys.forEach((key) => {
            if (key === 'file_templates') {
                const files = action.data.file_templates && action.data.file_templates.map(gb => gb.map(f => (f.file ? ({
                    ...f,
                    file: f.file.name,
                }) : null)));

                const flattenTemplate = flattenDeep(action.data.file_templates);
                flattenTemplate.forEach((value, ky) => {
                    const valueKeys = Object.keys(value);
                    valueKeys.forEach((v) => {
                        if ((v === 'file') && (value[v] !== undefined)) {
                            if ((v === 'file') && (value[v] === null)) {
                                formData.append(`templates_upload[${ky}]`, '');
                            } else if ((v === 'file') && (value[v].url)) {
                                formData.append(`templates_upload[${ky}]`, value[v].url);
                            } else if ((v === 'file') && (value[v].url === null)) {
                                formData.append(`templates_upload[${ky}]`, '');
                            } else if ((v === 'file') && (value[v].originFileObj)) {
                                formData.append(`templates_upload[${ky}]`, value[v].originFileObj);
                            }
                        }
                    });
                });

                if (action.data.file_templates && action.data.file_templates.length !== 0) {
                    formData.append('file_templates', JSON.stringify(flattenDeep(files).filter(x => !!x)));
                } else {
                    formData.append('file_templates', JSON.stringify([]));
                }
            } else if (key !== 'pages') {
                formData.append(key, action.data[key]);
            }
        });

        action.data.pages.forEach((value, key) => {
            const valueKeys = Object.keys(value);

            valueKeys.forEach((v) => {
                if ((v === 'page_masque' || v === 'page_stamp') && (value[v] === null)) {
                    formData.append(`pages[${key}][${v}]`, '');
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v].length === 0)) {
                    formData.append(`pages[${key}][${v}]`, '');
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v][0].url)) {
                    formData.append(`pages[${key}][${v}]`, value[v][0].url);
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v][0].url === null)) {
                    formData.append(`pages[${key}][${v}]`, '');
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v][0].originFileObj)) {
                    formData.append(`pages[${key}][${v}]`, value[v][0].originFileObj);
                } else if (v === 'page_folds_v' || v === 'page_folds_h') {
                    formData.append(`pages[${key}][${v}]`, JSON.stringify(value[v]));
                } else {
                    formData.append(`pages[${key}][${v}]`, value[v]);
                }
            });
        });

        const result = yield addTemplateApi(formData);

        if (result.status === 202) {
            yield put(addTemplateRes());
            yield put(push('/factory/templates/'));

            yield put(addTemplateRes(false, true));
            yield delay(1000);
            yield put(addTemplateRes(false, false));

            if (action.data.isClone) {
                yield call(clonePackagesToTemplateSaga, action.data);
            }
            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(addTemplateErr(error.message));
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error');
        yield put(addTemplateErr());
    }
}

export function* addTemplateWatcher() {
    yield takeLatest(ADD_TEMPLATE, addTemplateSaga);
}
// A D D   N E W   T E M P L A T E

// L O A D   E D I T A B L E   P A C K A G E S   F R O M   T E M P L A T E
function* loadEdiTablePackagesFromTemplateSaga(action) {
    const template = yield select(getTemplate);
    const { editTemp } = template;
    const { offset, limit } = template.packages_ids;

    try {
        if (action.ids !== undefined && action.ids.length) {
            let paramPackages = {};
            paramPackages = {
                filter: JSON.stringify({
                    _id: editTemp.deletePackages.length > 0 ? action.ids.filter(c => !editTemp.deletePackages.includes(c)) : action.ids,
                }),
                offset: editTemp.deletePackages.length > 0 && action.ids.filter(c => !editTemp.deletePackages.includes(c)).length < 11 ? 0 : offset,
                limit,
            };

            const resultPackage = yield getPackagesFromTemplateApi(paramPackages);

            const paramUsers = {
                filter: JSON.stringify({ _id: uniq(resultPackage.data.hits.map(h => h.created_by)) }),
            };

            const getUsers = yield getUsersApi(paramUsers);

            yield put(loadEdiTablePackagesFromTemplateRes({
                ...resultPackage.data,
                displayUsers: getUsers.data.hits,
            }));
        }
    } catch (e) {
        console.log(e);
        yield put(loadEdiTablePackagesFromTemplateErr());
    }
}

export function* loadEdiTablePackagesFromTemplateWatcher() {
    yield takeLatest(LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE, loadEdiTablePackagesFromTemplateSaga);
}
// L O A D   E D I T A B L E   P A C K A G E S   F R O M   T E M P L A T E

// L O A D   E D I T A B L E   T E M P L A T E
function* loadEdiTableTemplateSaga(action) {
    try {
        const paramTemplate = {
            filter: JSON.stringify({
                _id: action.id,
            }),
        };

        const resultTemplate = yield getTemplateApi(paramTemplate);

        if (resultTemplate.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Template don\'t exist',
            });

            yield put(push('/404'));
            yield put(addTemplateErr());
        } else {
            const template = resultTemplate.data.hits[0];
            yield put(loadEdiTableTemplateRes(template));
            yield call(loadEdiTablePackagesFromTemplateSaga, { ids: template.packages_id });
        }
    } catch (e) {
        console.log(e);
        yield put(addTemplateErr());
    }
}

export function* loadEdiTableTemplateWatcher() {
    yield takeLatest(LOAD_EDITTABLE_TEMPLATE, loadEdiTableTemplateSaga);
}
// L O A D   E D I T A B L E   T E M P L A T E

// E D I T   T E M P L A T E
function* editTemplateSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;
    const finalDescription = 'template.notification.TemplateEditedSuccess';
    try {
        const formData = new FormData();

        const dataKeys = Object.keys(action.data);
        dataKeys.forEach((key) => {
            if (key === 'file_templates') {
                const files = action.data.file_templates && action.data.file_templates.map(gb => gb.map(f => (f.file ? ({
                    ...f,
                    file: f.file.name,
                }) : null)));

                const flattenTemplate = flattenDeep(action.data.file_templates);
                flattenTemplate.forEach((value, ky) => {
                    const valueKeys = Object.keys(value);
                    valueKeys.forEach((v) => {
                        if ((v === 'file') && (value[v] !== undefined)) {
                            if ((v === 'file') && (value[v] === null)) {
                                formData.append(`templates_upload[${ky}]`, '');
                            } else if ((v === 'file') && (value[v].url)) {
                                formData.append(`templates_upload[${ky}]`, last(value[v].url.split('/flyerbeast/')));
                            } else if ((v === 'file') && (value[v].url === null)) {
                                formData.append(`templates_upload[${ky}]`, '');
                            } else if ((v === 'file') && (value[v].originFileObj)) {
                                formData.append(`templates_upload[${ky}]`, value[v].originFileObj);
                            }
                        }
                    });
                });

                if (action.data.file_templates.length !== 0) {
                    formData.append('file_templates', JSON.stringify(flattenDeep(files).filter(x => !!x)));
                } else {
                    formData.append('file_templates', JSON.stringify([]));
                }
            } else if (key !== 'pages') {
                formData.append(key, action.data[key]);
            }
        });

        action.data.pages.forEach((value, key) => {
            const valueKeys = Object.keys(value);

            valueKeys.forEach((v) => {
                if ((v === 'page_masque' || v === 'page_stamp') && (value[v] === null)) {
                    formData.append(`pages[${key}][${v}]`, '');
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v].length === 0)) {
                    formData.append(`pages[${key}][${v}]`, '');
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v][0].url)) {
                    formData.append(`pages[${key}][${v}]`, value[v][0].url.replace(process.env.REACT_APP_CDN, ''));
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v][0].url === null)) {
                    formData.append(`pages[${key}][${v}]`, '');
                } else if ((v === 'page_masque' || v === 'page_stamp') && (value[v][0].originFileObj)) {
                    formData.append(`pages[${key}][${v}]`, value[v][0].originFileObj);
                } else if (v === 'page_folds_v' || v === 'page_folds_h') {
                    formData.append(`pages[${key}][${v}]`, JSON.stringify(value[v]));
                } else {
                    formData.append(`pages[${key}][${v}]`, value[v]);
                }
            });
        });

        const result = yield editTemplateApi(formData);

        if (result.status === 202) {
            yield put(editTemplateRes());

            yield put(editTemplateRes(false, true));
            yield delay(500);
            yield put(editTemplateRes(false, false));
            yield put(push('/factory/templates/'));

            setNotification('success', locale, 'global.success', finalDescription);
        } else {
            const error = yield result.json();

            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(editTemplateErr(error.message));
        }
    } catch (e) {
        console.log(e);
        yield put(editTemplateErr());
    }
}

export function* editTemplateWatcher() {
    yield takeLatest(EDIT_TEMPLATE, editTemplateSaga);
}
// E D I T   T E M P L A T E

// T O G G L E   T E M P L A T E   S T A T U S
function* toggleTemplateStatusSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        let params = {};

        if (action.multiple) {
            params = action.tempParams;
        } else {
            params = {
                template_id: action.id,
                status: action.status,
            };
        }

        const result = yield toggleTemplateStatusApi(params);

        if (result.status === 202) {
            if (!action.multiple) {
                setNotification('success', locale, 'global.success', `template.notification.toggleStatus.${action.status}.success`);
                yield put(toggleTemplateStatusRes());
            } else {
                setNotification('success', locale, 'global.success', `template.notification.tempStatus.${action.status}.success`);
                yield put(CheckedTemplatesRes());
            }

            yield call(loadTemplateSaga, {});
        } else if (!action.multiple) {
            setNotification('error', locale, 'global.error', `template.notification.toggleStatus.${action.status}.error`);
            yield put(toggleTemplateStatusErr());
        } else {
            setNotification('error', locale, 'global.error', `template.notification.tempStatus.${action.status}.error`);
            yield put(CheckedTemplatesErr());
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', `template.notification.toggleStatus.${action.status}.error`);
        yield put(toggleTemplateStatusErr());
    }
}

export function* toggleTemplateStatusWatcher() {
    yield takeLatest(TOGGLE_TEMPLATE_STATUS, toggleTemplateStatusSaga);
}
// T O G G L E   T E M P L A T E   S T A T U S

// B U L K   C H E C K E D   T E M P L A T E
function* CheckedTemplatesSaga(action) {
    const { locale } = yield select(getLayout);
    const { temp, ids } = action;

    try {
        if (typeof temp === 'boolean') {
            const tempParams = { bulk: [] };
            for (let i = 0; i < ids.length; i += 1) {
                tempParams.bulk = tempParams.bulk.concat({ template_id: ids[i], status: temp });
            }

            yield call(toggleTemplateStatusSaga, {
                status: temp,
                tempParams,
                multiple: true,
            });
        }
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', `template.notification.toggleStatus.${temp}.error`);
        yield put(CheckedTemplatesErr());
    }
}

export function* CheckedTemplatesWatcher() {
    yield takeLatest(CHECKED_TEMPLATES, CheckedTemplatesSaga);
}
// B U L K   C H E C K E D   T E M P L A T E

// L O A D   P A C K A G E S   F O R   T E M P L A T E
function* loadPackagesForTemplateSaga() {
    const template = yield select(getTemplate);
    const { offset, limit, filters, sort } = template.packageConfigurations;

    try {
        const params = {
            offset,
            limit,
        };

        const sendFilters = {};

        if (filters.name !== '') {
            sendFilters.name = {
                operator: 'typing',
                value: filters.name,
            };
        }

        if (filters.created_by.length > 0) {
            sendFilters.created_by = filters.created_by;
        }

        params.filter = JSON.stringify(sendFilters);

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'name') {
                params.sort_by = JSON.stringify({ name: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        const result = yield getPackagesApi(params);

        const paramUsers = {
            filter: JSON.stringify({ _id: uniq(result.data.hits.map(h => h.created_by)) }),
        };
        const getUsers = yield getUsersApi(paramUsers);

        yield put(loadPackagesForTemplateRes({
            ...result.data,
            displayUsers: getUsers.data.hits,
        }));
    } catch (e) {
        console.log(e);
        yield put(loadPackagesForTemplateErr());
    }
}

export function* loadPackagesForTemplateWatcher() {
    yield takeEvery(LOAD_PACKAGES_FOR_TEMPLATE, loadPackagesForTemplateSaga);
}
// L O A D   P A C K A G E S   F O R   T E M P L A T E


// A D D   B U L K   P A C K A G E S
function* addBulkPackagesSaga(action) {
    const { locale } = yield select(getLayout);
    try {
        const { pathname } = window.location;
        const params = {
            package_id: action.data,
            template_id: pathname.substring(pathname.lastIndexOf('/') + 1),
        };

        const result = yield attachPackagesToTemplateApi(params);
        if (result.status === 202) {
            yield put(addBulkPackagesForTemplateRes());
            yield call(loadEdiTableTemplateSaga, { id: pathname.substring(pathname.lastIndexOf('/') + 1) });
            setNotification('success', locale, 'global.success', 'package.notification.addPackageToTemplate');
        } else {
            yield put(addBulkPackagesForTemplateErr(getTranslated('package.notification.addPackageToTemplateError', locale)));
            setNotification('error', locale, 'global.error', 'package.notification.addPackageToTemplateError');
        }
    } catch (e) {
        console.log(e);
        yield put(addBulkPackagesForTemplateErr(getTranslated('package.notification.addPackageToTemplateError', locale)));
        setNotification('error', locale, 'global.error', 'package.notification.addPackageToTemplateError');
    }
}

export function* addBulkPackagesForTemplateWatcher() {
    yield takeLatest(ADD_BULK_PACKAGES_FOR_TEMPLATE, addBulkPackagesSaga);
}
// A D D   B U L K   P A C K A G E S

// D E L E T E    B U L K   P A C K A G E S
function* deleteBulkPackagesSaga(action) {
    const { locale } = yield select(getLayout);
    try {
        const { pathname } = window.location;
        const params = {
            package_id: action.data,
            template_id: pathname.substring(pathname.lastIndexOf('/') + 1),
        };
        const result = yield detachPackagesToTemplateApi(params);

        if (result.status === 202) {
            yield put(deleteBulkPackagesForTemplateRes());
            yield call(loadEdiTableTemplateSaga, { id: pathname.substring(pathname.lastIndexOf('/') + 1) });
            setNotification('success', locale, 'global.success', 'package.notification.deletePackageToTemplate');
        }
    } catch (e) {
        console.log(e);
        yield put(deleteBulkPackagesForTemplateErr(getTranslated('package.notification.deleteBulkPackageError', locale)));
        setNotification('error', locale, 'global.error', 'package.notification.deleteBulkPackageError');
    }
}

export function* deleteBulkPackagesForTemplateWatcher() {
    yield takeLatest(DELETE_BULK_PACKAGES_FOR_TEMPLATE, deleteBulkPackagesSaga);
}
// D E L E T E    B U L K   P A C K A G E S

// L O A D   D E S I G N   T E M P L A T E
function* loadDesignTemplateSaga(action) {
    try {
        const template = yield select(getTemplate);
        const { offset, limit } = template;

        const params = {
            offset,
            limit,
            filter: JSON.stringify({
                template_id: action.id,
            }),
            joins: JSON.stringify(['product_group', 'reseller']),
        };

        const result = yield getDesignTemplateApi(params);
        const designTemplate = result.data;
        yield put(loadDesignTemplateRes(designTemplate));
    } catch (e) {
        console.log(e);
        yield put(loadDesignTemplateErr());
    }
}

export function* loadDesignTemplateWatcher() {
    yield takeLatest(LOAD_DESIGN_TEMPLATES, loadDesignTemplateSaga);
}
// L O A D   D E S I G N   T E M P L A T E


// L O A D   E D I T A B L E   D E S I G N   T E M P L A T E
function* loadEditableDesignTemplateSaga(action) {
    try {
        const params = { filter: JSON.stringify({ id: action.id }) };

        const result = yield getDesignTemplateApi(params);

        if (result.status === 200) {
            const hit = result.data.hits[0];
            yield put(loadEditableDesignTemplateRes(hit));
        } else {
            yield put(loadEditableDesignTemplateErr());
        }
    } catch (e) {
        console.log(e);
        yield put(loadEditableDesignTemplateErr());
    }
}

export function* loadEditableDesignTemplateWatcher() {
    yield takeLatest(LOAD_EDITABLE_DESIGN_TEMPLATES, loadEditableDesignTemplateSaga);
}
// L O A D   E D I T A B L E   D E S I G N   T E M P L A T E


// L O A D   R E S E L L E R S   F O R   D E S I G N   T E M P L A T E
function* loadResellersForDesignTemplateSaga() {
    try {
        const result = yield getResellersApi({ offset: 0, limit: 200 });

        const { hits } = result.data;
        yield put(loadResellersForDesignTemplateRes(hits));
    } catch (e) {
        console.log(e);
        yield put(loadResellersForDesignTemplateErr());
    }
}

export function* loadResellersForDesignTemplateWatcher() {
    yield takeLatest(LOAD_RESELLERS_FOR_DESIGN_TEMPLATES, loadResellersForDesignTemplateSaga);
}
// L O A D   R E S E L L E R S   F O R   D E S I G N   T E M P L A T E


// L O A D   P R O D U C T   G R O U P S   F O R   D E S I G N   T E M P L A T E
function* loadProductsGroupForDesignTemplateSaga() {
    try {
        const result = yield getProductGroupsApi({ offset: 0, limit: 500 });

        const { hits } = result.data;
        yield put(loadProductsGroupForDesignTemplateRes(hits));
    } catch (e) {
        console.log(e);
        yield put(loadProductsGroupForDesignTemplateErr());
    }
}

export function* loadProductsGroupForDesignTemplateWatcher() {
    yield takeLatest(LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES, loadProductsGroupForDesignTemplateSaga);
}
// L O A D   P R O D U C T   G R O U P S   F O R   D E S I G N   T E M P L A T E


// E D I T   D E S I G N   T E M P L A T E
function* updateDesignTemplateTranslate(action) {
    const type = 'add';
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const params = { bulk: [] };
        locales.forEach((lc) => {
            if (lc !== 'en' || (lc === 'en' && action.type === EDIT_DESIGN_TEMPLATE)) {
                params.bulk.push({
                    ...action.data[lc],
                });
            }
        });

        const result = yield updateTranslateDesignTemplateApi(params);

        if (result.status !== 202) {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
        }

        yield put(updateTranslateDesignTemplateRes(type, true, true));
        yield delay(50);
        yield put(updateTranslateDesignTemplateRes(type, false, false));
    } catch (e) {
        console.log(e);
        setNotification('error', locale, 'global.error', 'template.notification.translateErrorFunction');
        yield put(updateTranslateDesignTemplateErr(type, false, false));
    }
}

function* editDesignTemplateSaga(action) {
    const { locale } = yield select(getLayout);
    try {
        const formData = new FormData();
        formData.append('design_template_id', action.data.design_template_id);
        formData.append('template_id', action.data.template_id);
        formData.append('reseller_id', action.data.reseller_id);
        formData.append('resellers', JSON.stringify(action.data.resellers));
        formData.append('product_groups', JSON.stringify(action.data.product_groups));
        if (action.data.thumb.originFileObj) {
            formData.append('thumb', action.data.thumb.originFileObj);
        }
        formData.append('meta_tags', JSON.stringify(action.data.meta_tags));
        const result = yield editDesignTemplateApi(formData);

        if (result.status === 202) {
            yield call(updateDesignTemplateTranslate, action);
            const statusDesignTemplate = {
                design_template_id: action.data.design_template_id,
                status: action.data.status,
            };
            yield statusDesignTemplateApi(statusDesignTemplate);

            yield put(editDesignTemplateRes());
            yield put(push(`/factory/templates/edit/${action.data.template_id}`));

            setNotification('success', locale, 'global.success', 'template.notification.editDesignTemplateSuccess');
        } else {
            yield put(editDesignTemplateErr());
            setNotification('error', locale, 'global.error', 'template.notification.editDesignTemplateError');
        }
    } catch (e) {
        console.log(e);
        yield put(editDesignTemplateErr());
        setNotification('error', locale, 'global.error', 'template.notification.editDesignTemplateError');
    }
}

export function* editDesignTemplateWatcher() {
    yield takeLatest(EDIT_DESIGN_TEMPLATE, editDesignTemplateSaga);
}
// E D I T   D E S I G N   T E M P L A T E
